import "./App.css";
import { useEffect } from "react";
import DSRouter from "./DSRouter";
import { AppProvider } from "./utils/Reducers";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

function App() {
  useEffect(
    () => {
      const listenBackEvent = () => {
        const userAgent = window.navigator.userAgent;
        if (
          userAgent.indexOf("iPhone") > -1 ||
          userAgent.indexOf("Android") > -1
        ) {
          history.push("/mobile/main", { some: "state" });
        } else {
          history.push("/", { some: "state" });
        }
      };

      const unlistenHistoryEvent = history.listen(({ action }) => {
        if (action === "POP") {
          listenBackEvent();
        }
      });

      return unlistenHistoryEvent;
    },
    [
      // effect에서 사용하는 state를 추가
    ]
  );
  return (
    <AppProvider>
      <DSRouter />
    </AppProvider>
  );
}

export default App;
